export default "__VITE_ASSET__Cwbw_u5o__"